import * as ACTION_TYPES from '../types';

let initialState = {
  jobList: [],
  job: {},
  totalItems: Number,
  loading: false
}

export default (state = initialState, action) => {
    switch (action.type) {
      case ACTION_TYPES.GET_JOBS:
        return {...state, jobList: action.data, totalItems: action.totalItems };
      case ACTION_TYPES.REQUEST:
        return {...state, loading: true };
      case ACTION_TYPES.DONE:
        return {...state, loading: false };
      case ACTION_TYPES.RESET_JOBS:
        return {...state, jobList: []}
      case ACTION_TYPES.GET_JOBS_BY_EQUIPMENTNO: 
        return {...state, jobList: action.data}
      case ACTION_TYPES.GET_JOBS_BY_LOCATIONID: 
        return {...state, jobList: action.data}
      case ACTION_TYPES.GET_JOB_BY_ID: 
      return {...state,job: action.data}
      default:
        return state;
    }
  };